import * as React from "react";
import {
  Grid,
  Typography,
  withStyles,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { ProfileStore } from "modules/profile/ProfileStore";
import i18n from "i18n";
import { observer } from "mobx-react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { ProfileService } from "modules/profile/ProfileService";
import { toJS } from "mobx";
import { NoResultsSearchFound } from "modules/development/components/layouts";
import NoUsersFound from "../layouts/NoUsersFound";
import LayerAddUser from "./LayerAddUser";
import UserRow from "../layouts/UserRow";
import { LoginStore } from "modules/login/LoginStore";
const styles = (theme) => ({
  root: {
    width: "100%",
  },

  table: {
    width: "950px!important",
    backgroundColor: "white",
    marginBottom: "5%",
  },
  companyTitle: {
    fontFamily: "Roboto",
    fontSize: "22px",
    letterSpacing: "1.2px",
    marginBottom: "3%",
  },
  gridContent: {
    marginTop: "65px",
    display: "grid",
    gridTemplateColumns: "90px 1fr",
    gridColumnGap: "45px",
    maxWidth: "1000px!important",
    margin: "0 auto",
  },
  message: {
    "& > :first-child > :first-child": {
      maxWidth: "calc(100% - 64px)",
    },
  },
  gridSearch: {
    display: "table",
    height: "100%",
    "& > :first-child": {
      display: "table-cell",
      height: "100%",
      verticalAlign: "middle",
    },
  },
  buttonActive: {
    backgroundColor: "#ABC200",
    color: "black",
    "&:hover": {
      backgroundColor: "#92A501",
    },
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  circularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btnAddContributors: {
    height: "50px",
  },
  btnInactive: {
    backgroundColor: "#d4d4d4",
    color: "#7c7c7c",
    width: "100%",
  },
  btnActive: {
    backgroundColor: "#ebf3a3",
    color: "#9da65a",
    width: "100%",
  },
});

type IProps = {
  classes: any;
  searchUser: any;
};

@observer
class Users extends React.Component<IProps> {
  state = {
    companyName: ProfileStore.companyName != "" ? ProfileStore.companyName : "",
    isLoading: true,
    userAccessOperatorEl: null,
    open: false,
    currentUserUid: "",
  };

  handleClickOpenModal = () => {
    this.setState({ open: true });
  };

  handleCloseModal = () => {
    this.setState({ open: false });
  };
  componentDidMount() {
    document.title = `Rubk - ${i18n.menu.account.view}`;
    setTimeout(() => {
      if (this.state.companyName != "") {
        ProfileStore.companyInfos = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    document.title = "Rubk";
  }

  componentWillMount = async () => {
    ProfileStore.setProviders();
    this.loadingCompanyInfos();
    await this.getUsers();
    let currentUser: any = await LoginStore.getAuthenticatedUserData();
    this.state.currentUserUid = currentUser.uid;
  };

  handleOpenLayerAdd = () => {
    ProfileStore.layerAdd = true;
    this.setState({});
  };

  async loadingCompanyInfos() {
    await ProfileStore.getCompanyInfos();
    this.setState({ companyName: ProfileStore.companyName });
  }

  async getUsers() {
    let uid = ProfileService.getUserId();
    let users = await ProfileService.getUsers(uid);
    this.setState({ companyUsers: users });
    this.setState({ isLoading: false });
  }

  render() {
    const { classes } = this.props,
      { companyName } = this.state;

    return (
      <>
        <LayerAddUser />

        {ProfileStore.usersView.length > 0 ? (
          <Grid container className={classes.container}>
            <div style={{ paddingBottom: "5rem" }}>
              <div className={classes.gridContent}>
                <div>
                  <div className={classes.blockContributors}>
                    <Typography className={classes.companyTitle}>
                      {companyName}
                    </Typography>

                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnAddContributors}
                      onClick={this.handleOpenLayerAdd}
                      disabled={!ProfileStore.isCurrentUserAdmin}
                    >
                      {i18n.contributors.addContributors}
                    </Button>
                  </div>

                  <div className={classes.root}>
                    {this.state.isLoading ? (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          backgroundColor: "#fff",
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          zIndex: 2,
                        }}
                      >
                        <CircularProgress
                          size={100}
                          style={{ margin: "0 auto", color: "#9FB408" }}
                        />
                        <Typography
                          style={{
                            position: "absolute",
                            marginLeft: "calc(50% - 65px)",
                            marginTop: "170px",
                          }}
                        >
                          {i18n.contributors.loading}
                        </Typography>
                      </div>
                    ) : ProfileStore.usersView.length > 0 ? (
                      <Table className={classes.table}>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>
                              {i18n.profile.contributors.name}
                            </TableCell>
                            <TableCell>E-mail</TableCell>
                            {ProfileStore.isCurrentUserAdmin ? (
                              <TableCell>
                                {i18n.profile.contributors.access}
                              </TableCell>
                            ) : (
                              ""
                            )}
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {toJS(ProfileStore.usersView).map((item, key) => {
                            return <UserRow key={key} item={item} />;
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        ) : (
          <>
            <div>
              <div className={classes.gridContent}>
                <div>
                  <div className={classes.blockContributors}>
                    <Typography className={classes.companyTitle}>
                      {companyName}
                    </Typography>

                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnAddContributors}
                      onClick={this.handleOpenLayerAdd}
                      disabled={!ProfileStore.isCurrentUserAdmin}
                    >
                      {i18n.contributors.addContributors}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {ProfileStore.users.length > 0 ? (
              <NoResultsSearchFound />
            ) : (
              <NoUsersFound />
            )}
          </>
        )}
      </>
    );
  }
}

export default withStyles(styles)(Users);



// WEBPACK FOOTER //
// ./src/modules/profile/components/pages/Users.tsx